// extracted by mini-css-extract-plugin
export var Quote = "Quote-module--Quote--+-uuU";
export var Quote_card = "Quote-module--Quote_card--tKQnF";
export var Quote_card_desc = "Quote-module--Quote_card_desc--Ql9cz";
export var Quote_card_user = "Quote-module--Quote_card_user--mF-nL";
export var Quote_card_user_details = "Quote-module--Quote_card_user_details--LY8YG";
export var Quote_card_user_details_company = "Quote-module--Quote_card_user_details_company--QNoKq";
export var Quote_card_user_details_name = "Quote-module--Quote_card_user_details_name--htmqT";
export var Quote_card_user_img = "Quote-module--Quote_card_user_img--yZw1-";
export var Quote_img = "Quote-module--Quote_img--ilPSP";